export default function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-800 border-t p-4 text-sm text-center text-gray-500 dark:text-gray-400">
      © 2025 NGC Financial Services · All rights reserved.
    </footer>
  );
}